import { TimeagoIntl } from 'ngx-timeago';

export class MomentIntl extends TimeagoIntl {}
